import clsx from 'clsx'
import css from 'component/Button/CircleButton.module.scss'
import { CSSProperties, MouseEvent, ReactNode } from 'react'
import { styles } from 'util/style'

type Props = {
  children?: ReactNode
  className?: string
  clear?: boolean
  disabled?: boolean
  onClick?: (event: MouseEvent) => unknown
  style?: CSSProperties
  size?: number
}

export function CircleButton(props: Props) {
  const { children, clear, disabled, onClick, size } = props
  const type = clear ? css.clear : css.default
  const className = clsx(props.className, css.button, type, disabled && css.disabled)
  const style = styles({ ...props.style, width: size, height: size })

  return <div className={className} style={style} onClick={onClick}>
    {children}
  </div>
}
